import { Button } from "components/Button";
import { CalendarIcon, LocationIcon, WebsiteIcon } from "components/Icons";
import {
  DATE_AND_TIME_TYPE,
  LOCATION_TYPE,
  SMALL,
  TYPE_RICHTEXT_SIMPLE,
  WEBSITE_TYPE,
} from "shared/constants";
import { MaxWidth } from "components/MaxWidth";
import { onlyLinkSerializers } from "components/Content";
import { RichText } from "components/RichText";
import { translate, DATE_AND_TIME, LOCATION, WEBSITE } from "shared/translate";
import { useRouter } from "next/router";
import BlockContent from "@sanity/block-content-to-react";
import styles from "./EventDetails.module.css";

const ICONS = {
  [DATE_AND_TIME_TYPE]: <CalendarIcon />,
  [LOCATION_TYPE]: <LocationIcon />,
  [WEBSITE_TYPE]: <WebsiteIcon />,
};

const TRANSLATION_TYPES = {
  [DATE_AND_TIME_TYPE]: DATE_AND_TIME,
  [LOCATION_TYPE]: LOCATION,
  [WEBSITE_TYPE]: WEBSITE,
};

export const EventDetailsContainer = ({ size = SMALL, ...rest }) => (
  <div className={styles.container}>
    <MaxWidth size={size}>
      <EventDetails {...rest} />
    </MaxWidth>
  </div>
);
export const EventDetails = ({ items, button }) => {
  const { locale } = useRouter();

  if (!Boolean(items.length) && !button?.label) return null;

  return (
    <div className={styles.wrapper}>
      {Boolean(items.length) && (
        <div className={styles.details}>
          {items.map(({ type, text }, i) => (
            <div key={i} className={styles.item}>
              <div className={styles.iconWrapper}>
                <div className={styles.icon}>{ICONS[type]}</div>
              </div>
              <div className={styles.contentWrapper}>
                <RichText type={TYPE_RICHTEXT_SIMPLE}>
                  <strong>{translate(TRANSLATION_TYPES[type], locale)}</strong>
                  <BlockContent
                    blocks={text}
                    serializers={onlyLinkSerializers}
                  />
                </RichText>
              </div>
            </div>
          ))}
        </div>
      )}

      {button && button.label && (
        <div className={styles.footer}>
          <Button {...button}>{button.label}</Button>
        </div>
      )}
    </div>
  );
};
